import { render, staticRenderFns } from "./additional_metadata_loader.vue.js?vue&type=template&id=6abc4a42!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./additional_metadata_loader.vue?vue&type=template&id=6abc4a42"
import script from "./additional_metadata_loader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./additional_metadata_loader.vue?vue&type=script&lang=js"
export * from "./additional_metadata_loader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./additional_metadata_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports